import Item from "Components/Item";
import { FC } from "react";
import xml2js from "xml2js";
import { useState, useEffect } from "react";
import { Wrapper } from "./Editorial.styled";
import Title from "Components/Title";

interface Props {
  editorialFeed: any;
}

const Editorial: FC<Props> = ({ editorialFeed }) => {
  const [result, setResult] = useState<any[]>();

  useEffect(() => {
    let parser = new xml2js.Parser();
    parser.parseString(editorialFeed, function (err: string, result: any) {
      if (result) {
        setResult(result.editorial && result.editorial.item);
      }
    });
  }, []);

  if (!result) {
    return null;
  }

  return (
    <>
      <Title type="jobs">Career news and advice</Title>

      <Wrapper>
        {result.map(
          (
            item: { link: [string]; title: string; imgLink: [string] },
            i: number
          ) => {
            return (
              <Item
                key={i}
                size={2}
                role="job"
                article={{
                  path: item.link[0],
                  titleShort: item.title,
                  hero: [
                    {
                      data: {
                        url: item.imgLink[0],
                      },
                    },
                  ],
                }}
              />
            );
          }
        )}
      </Wrapper>
    </>
  );
};

export default Editorial;
